// History Curriculum Data - Vanuatu National Syllabus
// Years 11-13 Senior Secondary

export const historyCurriculum = {
  year11: {
    title: "Year 11 History",
    description: "Introduction to historical skills and Vanuatu's journey from early societies to independence",
    hours: 132,
    strands: [
      {
        id: "11HIS1",
        name: "Skills of History",
        icon: "Search",
        color: "blue",
        hours: 20,
        weight: 15,
        outcome: "Demonstrate understanding of different historical sources and how to evaluate and analyse information",
        subStrands: [
          {
            id: "11HIS1.1",
            name: "Personalizing History",
            outcome: "Demonstrate understanding of the relationship with history and its importance in student lives",
            topics: [
              { code: "11HIS1.1.3.1", topic: "Explain the historical meanings of the student's village and own name", level: 3 },
              { code: "11HIS1.1.3.2", topic: "Express viewpoints about individual relationship with own family history", level: 3 },
              { code: "11HIS1.1.3.3", topic: "Explain how historical events of the past shape the present", level: 3 },
              { code: "11HIS1.1.3.4", topic: "Formulate research questions for a study of history or oral traditions", level: 3 },
              { code: "11HIS1.1.3.5", topic: "Collect the required data and information", level: 3 },
              { code: "11HIS1.1.3.6", topic: "Analyse the data and information collected", level: 3 },
              { code: "11HIS1.1.4.1", topic: "Report on the process and findings of the research outcome", level: 4 },
              { code: "11HIS1.1.4.2", topic: "Discuss how history is significant in students' daily lives using specific examples", level: 4 }
            ]
          },
          {
            id: "11HIS1.2",
            name: "Studying History",
            outcome: "Demonstrate understanding of the importance of History",
            topics: [
              { code: "11HIS1.2.1.1", topic: "Define the term History in their own words", level: 1 },
              { code: "11HIS1.2.1.2", topic: "Name the different periods in history", level: 1 },
              { code: "11HIS1.2.3.1", topic: "Explain why it is important to study History as a class subject", level: 3 },
              { code: "11HIS1.2.3.2", topic: "Explain the importance of studying History through non-verbal text", level: 3 }
            ]
          },
          {
            id: "11HIS1.3",
            name: "Historical Sources",
            outcome: "Demonstrate understanding of the various historical sources",
            topics: [
              { code: "11HIS1.3.1.1", topic: "Define oral traditions", level: 1 },
              { code: "11HIS1.3.1.2", topic: "Define a Primary source", level: 1 },
              { code: "11HIS1.3.1.3", topic: "Define a Secondary source", level: 1 },
              { code: "11HIS1.3.2.1", topic: "List the available tools for studying History", level: 2 },
              { code: "11HIS1.3.3.1", topic: "Differentiate between primary and secondary sources of information", level: 3 },
              { code: "11HIS1.3.3.2", topic: "Distinguish between oral traditions and oral testimonies", level: 3 },
              { code: "11HIS1.3.3.3", topic: "Explain the links between primary and secondary sources", level: 3 }
            ]
          },
          {
            id: "11HIS1.4",
            name: "Historical Enquiry",
            outcome: "Demonstrate understanding of the process of historical enquiry",
            topics: [
              { code: "11HIS1.4.1.1", topic: "Define the term historical enquiry", level: 1 },
              { code: "11HIS1.4.1.2", topic: "Select relevant information from a variety of sources", level: 1 },
              { code: "11HIS1.4.2.1", topic: "List the steps for carrying out a historical enquiry", level: 2 },
              { code: "11HIS1.4.4.1", topic: "Formulate hypothesis from the collected information", level: 4 },
              { code: "11HIS1.4.4.2", topic: "Support or refute hypothesis on the basis of valid/invalid reasons", level: 4 }
            ]
          }
        ]
      },
      {
        id: "11HIS2",
        name: "Early History of Vanuatu",
        icon: "MapPin",
        color: "green",
        hours: 25,
        weight: 19,
        outcome: "Demonstrate understanding of the social, political and economic arrangements of early Vanuatu societies",
        subStrands: [
          {
            id: "11HIS2.1",
            name: "Origins of Vanuatu",
            outcome: "Demonstrate understanding of the origins of the first people on the islands of Vanuatu",
            topics: [
              { code: "11HIS2.1.1.1", topic: "Name the traditional and/or island gods", level: 1 },
              { code: "11HIS2.1.1.2", topic: "Recite the custom stories of traditional creations", level: 1 },
              { code: "11HIS2.1.1.3", topic: "Identify evidence of traditional creation stories", level: 1 },
              { code: "11HIS2.1.2.1", topic: "Describe available evidence of the first people on students' own islands", level: 2 },
              { code: "11HIS2.1.3.1", topic: "Compare scientific evidence and oral traditions of the inhabitants", level: 3 }
            ]
          },
          {
            id: "11HIS2.2",
            name: "Organization of Early Vanuatu Societies",
            outcome: "Demonstrate understanding of the social, political and economic arrangements of early Vanuatu society",
            topics: [
              { code: "11HIS2.2.1.1", topic: "State examples of different beliefs throughout the islands of Vanuatu", level: 1 },
              { code: "11HIS2.2.2.1", topic: "List the different systems of land ownership in Vanuatu", level: 2 },
              { code: "11HIS2.2.2.2", topic: "Describe the political, social and economical situation of early Vanuatu", level: 2 },
              { code: "11HIS2.2.3.1", topic: "Explain the different systems of land ownership based on respective islands", level: 3 },
              { code: "11HIS2.2.4.1", topic: "Discuss the traditional values of Vanuatu's customs", level: 4 }
            ]
          },
          {
            id: "11HIS2.3",
            name: "Traditional Systems: Agriculture and Education",
            outcome: "Demonstrate understanding of the agricultural and educational systems in traditional Vanuatu societies",
            topics: [
              { code: "11HIS2.3.1.1", topic: "Identify the different agricultural systems in Vanuatu", level: 1 },
              { code: "11HIS2.3.1.2", topic: "Identify the different educational systems in Vanuatu", level: 1 },
              { code: "11HIS2.3.2.1", topic: "Describe the main features of different agricultural systems", level: 2 },
              { code: "11HIS2.3.3.1", topic: "Compare Vanuatu's traditional irrigation systems with others around the world", level: 3 },
              { code: "11HIS2.3.4.1", topic: "Discuss advantages and disadvantages of traditional agricultural systems", level: 4 }
            ]
          },
          {
            id: "11HIS2.4",
            name: "Events of the Shepherds: Roy Mata and Kuwae",
            outcome: "Demonstrate understanding of the contributions of Roy Mata and the impacts of the Kuwae volcanic eruption",
            topics: [
              { code: "11HIS2.4.1.1", topic: "Identify the islands of Shepherds Group", level: 1 },
              { code: "11HIS2.4.1.2", topic: "Locate the Kuwae spot on a map", level: 1 },
              { code: "11HIS2.4.2.1", topic: "Describe the significant contributions of Roy Mata's peace process", level: 2 },
              { code: "11HIS2.4.3.1", topic: "Explain why Roy Mata is important in the history of Vanuatu", level: 3 },
              { code: "11HIS2.4.3.3", topic: "Analyse the Roy Mata legend against scientific evidence", level: 3 }
            ]
          }
        ]
      },
      {
        id: "11HIS3",
        name: "Forces of Imperialism and Colonialism",
        icon: "Globe",
        color: "purple",
        hours: 20,
        weight: 15,
        outcome: "Demonstrate understanding of the nature and impact of imperialism and colonialism on Pacific societies",
        subStrands: [
          {
            id: "11HIS3.1",
            name: "Forces of Imperialism and Colonialism",
            outcome: "Demonstrate understanding of imperialism and colonialism and how they eroded traditional leadership systems",
            topics: [
              { code: "11HIS3.1.1.1", topic: "Define Imperialism and colonialism", level: 1 },
              { code: "11HIS3.1.1.2", topic: "Name some examples of imperialism and colonialism", level: 1 },
              { code: "11HIS3.1.1.3", topic: "Identify the major imperialist and colonialist powers of the Pacific", level: 1 },
              { code: "11HIS3.1.2.1", topic: "Describe the main common features of traditional Pacific leadership systems", level: 2 },
              { code: "11HIS3.1.3.1", topic: "Explain the differences between imperialism and colonialism", level: 3 },
              { code: "11HIS3.1.3.2", topic: "Explain the main motives for imperialist/colonialist expansions into the Pacific", level: 3 }
            ]
          },
          {
            id: "11HIS3.2",
            name: "Aristocratic Leadership Systems of Polynesia and Micronesia",
            outcome: "Demonstrate understanding of how leadership positions were acquired in Polynesian and Micronesian cultural areas",
            topics: [
              { code: "11HIS3.2.1.1", topic: "Define aristocracy", level: 1 },
              { code: "11HIS3.2.1.2", topic: "Name the three main cultural and ethnic areas of the Pacific", level: 1 },
              { code: "11HIS3.2.2.1", topic: "List the countries in the Polynesian area", level: 2 },
              { code: "11HIS3.2.2.2", topic: "List the countries in the Micronesian area", level: 2 },
              { code: "11HIS3.2.3.1", topic: "Explain how aristocratic leadership systems were established", level: 3 }
            ]
          },
          {
            id: "11HIS3.3",
            name: "Democratic Leadership Systems of Melanesia",
            outcome: "Demonstrate understanding of leadership acquisition in the Melanesian cultural area",
            topics: [
              { code: "11HIS3.3.1.1", topic: "Define democracy", level: 1 },
              { code: "11HIS3.3.1.2", topic: "Identify the Melanesian cultural area", level: 1 },
              { code: "11HIS3.3.2.1", topic: "Describe the origins of democracy", level: 2 },
              { code: "11HIS3.3.2.2", topic: "List the countries in the Melanesian areas", level: 2 },
              { code: "11HIS3.3.3.1", topic: "Explain how the leadership systems in Melanesia were established", level: 3 }
            ]
          },
          {
            id: "11HIS3.4",
            name: "Reasons for Different Traditional Leadership Systems",
            outcome: "Demonstrate understanding of the causes of different traditional leadership systems in the Pacific",
            topics: [
              { code: "11HIS3.4.2.1", topic: "Describe the features of aristocratic and democratic leadership systems", level: 2 },
              { code: "11HIS3.4.2.2", topic: "Match leadership systems to cultural areas on a map", level: 2 },
              { code: "11HIS3.4.3.1", topic: "Explain the reasons/motives for establishing such leadership systems", level: 3 }
            ]
          }
        ]
      },
      {
        id: "11HIS4",
        name: "Interwar Period",
        icon: "Swords",
        color: "red",
        hours: 21,
        weight: 16,
        outcome: "Demonstrate understanding of the nature and impact of activities during the inter-war period on Pacific societies",
        subStrands: [
          {
            id: "11HIS4.1",
            name: "World War I",
            outcome: "Demonstrate understanding of the causes of WWI and its effects on Europe and the Pacific",
            topics: [
              { code: "11HIS4.1.1.1", topic: "State the different causes of World War I", level: 1 },
              { code: "11HIS4.1.2.1", topic: "Describe the main features of World War I", level: 2 },
              { code: "11HIS4.1.2.2", topic: "List the Axis Powers and Allied Powers involved in the Great War", level: 2 },
              { code: "11HIS4.1.3.1", topic: "Explain how these causes resulted in World War I by 1914", level: 3 },
              { code: "11HIS4.1.4.1", topic: "Evaluate the effects of the War on Europe using specific examples", level: 4 },
              { code: "11HIS4.1.4.2", topic: "Discuss the effects of the War on the Pacific Islands", level: 4 }
            ]
          },
          {
            id: "11HIS4.2",
            name: "World War II",
            outcome: "Demonstrate understanding of the origins of WWII in Europe and the Pacific",
            topics: [
              { code: "11HIS4.2.1.1", topic: "Name the countries involved in World War II in Europe", level: 1 },
              { code: "11HIS4.2.2.1", topic: "Outline the causes of World War II", level: 2 },
              { code: "11HIS4.2.2.2", topic: "List the countries in Europe according to Allied and Axis Powers division", level: 2 },
              { code: "11HIS4.2.4.1", topic: "Evaluate the effects of WWII on Europe using specific examples", level: 4 },
              { code: "11HIS4.2.4.2", topic: "Discuss the effects of the War on the Pacific Islands", level: 4 }
            ]
          },
          {
            id: "11HIS4.3",
            name: "The Pacific War",
            outcome: "Demonstrate understanding of Pacific island nations directly affected by WWII",
            topics: [
              { code: "11HIS4.3.1.1", topic: "Locate the war-zone areas in the Pacific on a historical map", level: 1 },
              { code: "11HIS4.3.2.1", topic: "Sketch the route or directions of World War II into the Pacific", level: 2 },
              { code: "11HIS4.3.3.1", topic: "Explain how World War II entered the Pacific", level: 3 }
            ]
          },
          {
            id: "11HIS4.4",
            name: "Involvement of Pacific Islanders",
            outcome: "Demonstrate understanding of the experiences of Pacific islanders pre and post-WWII",
            topics: [
              { code: "11HIS4.4.1.1", topic: "Identify Pacific islands or communities greatly affected by the War", level: 1 },
              { code: "11HIS4.4.3.1", topic: "Compare the impacts of war on directly and indirectly affected areas", level: 3 }
            ]
          }
        ]
      },
      {
        id: "11HIS5",
        name: "Period of Decolonization",
        icon: "Flag",
        color: "orange",
        hours: 20,
        weight: 15,
        outcome: "Demonstrate understanding of the various milestones and origins of decolonization",
        subStrands: [
          {
            id: "11HIS5.1",
            name: "The New Hebrides Condominium after WWII",
            outcome: "Demonstrate understanding of the political situation of the New Hebrides condominium after WWII",
            topics: [
              { code: "11HIS5.1.1.1", topic: "Define the term condominium", level: 1 },
              { code: "11HIS5.1.1.2", topic: "Identify important events that marked different political situations post-WWII", level: 1 },
              { code: "11HIS5.1.2.1", topic: "List examples of countries governed under a condominium system", level: 2 },
              { code: "11HIS5.1.2.2", topic: "Describe the main political governance system of Condominium rule", level: 2 },
              { code: "11HIS5.1.3.1", topic: "Compare the political situations in pre and post WWII New Hebrides", level: 3 }
            ]
          },
          {
            id: "11HIS5.2",
            name: "Political Situation of Pacific Islands after WWII",
            outcome: "Demonstrate understanding of the political situation of Pacific island countries post-WWII",
            topics: [
              { code: "11HIS5.2.1.1", topic: "Select a Pacific Island colonial territory of choice", level: 1 },
              { code: "11HIS5.2.2.1", topic: "Describe the selected territory's governance system prior to colonial control", level: 2 },
              { code: "11HIS5.2.3.1", topic: "Explain differences between traditional governance and colonial rule", level: 3 },
              { code: "11HIS5.2.4.1", topic: "Discuss the UN role in developments towards decolonization", level: 4 }
            ]
          },
          {
            id: "11HIS5.3",
            name: "Situation of Colonial Countries after WWII",
            outcome: "Demonstrate understanding of the situation of colonial countries after WWII",
            topics: [
              { code: "11HIS5.3.1.1", topic: "Identify the different colonial powers that existed after WWII", level: 1 },
              { code: "11HIS5.3.1.2", topic: "Locate these existing post WWII colonial powers on a historical map", level: 1 },
              { code: "11HIS5.3.3.1", topic: "Summarize the aims and objectives of colonial governments pre-WWII", level: 3 },
              { code: "11HIS5.3.3.2", topic: "Summarize the aims and objectives of colonial governments post-WWII", level: 3 },
              { code: "11HIS5.3.4.1", topic: "Discuss the socio-economic policies of colonial governments after WWII", level: 4 }
            ]
          },
          {
            id: "11HIS5.4",
            name: "UN Role in Decolonization",
            outcome: "Demonstrate understanding of the involvement of the UN in the decolonization process",
            topics: [
              { code: "11HIS5.4.1.1", topic: "Name the countries that received UN financial assistance for decolonization", level: 1 },
              { code: "11HIS5.4.2.1", topic: "Outline the stages of how UN was established", level: 2 },
              { code: "11HIS5.4.2.2", topic: "Describe the general aims and roles of the United Nations", level: 2 },
              { code: "11HIS5.3.3.1", topic: "Explain the importance of the Universal Declaration of Human Rights", level: 3 }
            ]
          }
        ]
      },
      {
        id: "11HIS6",
        name: "From Independence to the Present",
        icon: "Landmark",
        color: "teal",
        hours: 26,
        weight: 20,
        outcome: "Demonstrate understanding of the history of Vanuatu's road to political independence",
        subStrands: [
          {
            id: "11HIS6.1",
            name: "The Rise of National Liberation Movements",
            outcome: "Demonstrate understanding of how decolonization resulted in national liberation movements",
            topics: [
              { code: "11HIS6.1.1.1", topic: "Define national consciousness", level: 1 },
              { code: "11HIS6.1.2.1", topic: "List the contributing factors to the emergence of national consciousness", level: 2 },
              { code: "11HIS6.1.2.2", topic: "Describe the features of traditional/cultural nationalism in Vanuatu", level: 2 },
              { code: "11HIS6.1.3.1", topic: "Compare traditional/cultural nationalism with modern nationalism", level: 3 },
              { code: "11HIS6.1.3.2", topic: "Explain the role of religion and custom in the rise of national consciousness", level: 3 }
            ]
          },
          {
            id: "11HIS6.2",
            name: "Indigenous Movements in the Pacific",
            outcome: "Demonstrate understanding of the ideologies of various indigenous movements in the Pacific",
            topics: [
              { code: "11HIS6.2.1.1", topic: "Name any political indigenous movement in the Pacific", level: 1 },
              { code: "11HIS6.2.1.2", topic: "Match the indigenous movements to their Pacific islands of origin", level: 1 },
              { code: "11HIS6.2.2.1", topic: "Describe the motives for the establishments of indigenous movements", level: 2 },
              { code: "11HIS6.2.3.1", topic: "Explain indigenous movements", level: 3 },
              { code: "11HIS6.2.4.1", topic: "Evaluate the challenges faced by indigenous movements", level: 4 }
            ]
          },
          {
            id: "11HIS6.3",
            name: "Indigenous Movements in Vanuatu",
            outcome: "Demonstrate understanding of indigenous movements in the struggle for independence in Vanuatu",
            topics: [
              { code: "11HIS6.3.1.1", topic: "Name any indigenous political movements in Vanuatu prior to independence", level: 1 },
              { code: "11HIS6.3.1.2", topic: "Match the indigenous movements to their islands of origin in Vanuatu", level: 1 },
              { code: "11HIS6.3.2.1", topic: "Describe the motives for the establishments of these movements", level: 2 },
              { code: "11HIS6.3.2.2", topic: "Describe the challenges that faced these indigenous movement developments", level: 2 },
              { code: "11HIS6.3.4.1", topic: "Discuss how these movements played vital roles towards decolonisation", level: 4 }
            ]
          },
          {
            id: "11HIS6.4",
            name: "Challenges to Independent Vanuatu",
            outcome: "Demonstrate understanding of the social and cultural challenges within Vanuatu",
            topics: [
              { code: "11HIS6.4.1.1", topic: "Define the dual system experienced in Vanuatu", level: 1 },
              { code: "11HIS6.4.1.2", topic: "Identify examples of socio-cultural challenges to Vanuatu's road to independence", level: 1 },
              { code: "11HIS6.4.2.1", topic: "List the challenges that faced independent Vanuatu after 1980", level: 2 },
              { code: "11HIS6.4.3.1", topic: "Elaborate on the relationship between Franco-Catholics and Anglo-Protestants", level: 3 },
              { code: "11HIS6.4.4.1", topic: "Critically analyse the causes of differences between Anglophones and Francophones", level: 4 }
            ]
          }
        ]
      }
    ]
  },
  year12: {
    title: "Year 12 History",
    description: "Advanced study of historical methods, colonial impacts, and the path to independence",
    hours: 165,
    strands: [
      {
        id: "12HIS1",
        name: "Skills of History",
        icon: "Search",
        color: "blue",
        hours: 25,
        weight: 15,
        outcome: "Demonstrate understanding of historical sources and how to evaluate and analyse information",
        subStrands: [
          {
            id: "12HIS1.1",
            name: "Gathering Information",
            outcome: "Demonstrate understanding of methods by which historical information is obtained",
            topics: [
              { code: "12HIS1.1.1.1", topic: "Identify the different methods for gathering historical information", level: 1 },
              { code: "12HIS1.1.1.2", topic: "State the advantages of each of the methods", level: 1 },
              { code: "12HIS1.1.1.3", topic: "State the disadvantages of each of the methods", level: 1 },
              { code: "12HIS1.1.2.1", topic: "List the different methods for collecting historical information", level: 2 },
              { code: "12HIS1.1.3.1", topic: "Explain the importance of each of these methods", level: 3 },
              { code: "12HIS1.1.4.1", topic: "Evaluate the limitations of these methods in acquiring historical information", level: 4 }
            ]
          },
          {
            id: "12HIS1.2",
            name: "Analysing Information from Non-verbal Texts",
            outcome: "Demonstrate understanding in examining, interpreting and making generalizations from non-verbal texts",
            topics: [
              { code: "12HIS1.2.1.1", topic: "Name a variety of non-verbal texts", level: 1 },
              { code: "12HIS1.2.1.2", topic: "Identify non-verbal texts", level: 1 },
              { code: "12HIS1.2.2.1", topic: "Describe the importance of these non-verbal texts", level: 2 },
              { code: "12HIS1.2.3.1", topic: "Summarise the information in non-verbal texts", level: 3 },
              { code: "12HIS1.2.3.2", topic: "Interpret significant messages portrayed through non-verbal texts", level: 3 },
              { code: "12HIS1.2.4.1", topic: "Draw conclusions from key messages in non-verbal texts", level: 4 }
            ]
          },
          {
            id: "12HIS1.3",
            name: "Examining Verbal Texts/Written Sources",
            outcome: "Demonstrate understanding of how to analyse, interpret and make generalizations from verbal texts",
            topics: [
              { code: "12HIS1.3.1.1", topic: "Identify examples of verbal texts", level: 1 },
              { code: "12HIS1.3.1.2", topic: "State the importance of publication dates in verbal texts", level: 1 },
              { code: "12HIS1.3.2.1", topic: "Describe the contents of these verbal texts", level: 2 },
              { code: "12HIS1.3.3.1", topic: "Discuss the status of the writer as a secondary or primary source", level: 3 },
              { code: "12HIS1.3.4.1", topic: "Evaluate the relationship between text and general historical context", level: 4 }
            ]
          },
          {
            id: "12HIS1.4",
            name: "Evaluating Historical Sources",
            outcome: "Demonstrate understanding of how to compare historical sources and assess differences",
            topics: [
              { code: "12HIS1.4.1.1", topic: "Identify other important sources that produce historical information", level: 1 },
              { code: "12HIS1.4.1.2", topic: "Identify/Name the authors of these sources", level: 1 },
              { code: "12HIS1.4.2.1", topic: "Describe information from a variety of different sources", level: 2 },
              { code: "12HIS1.4.3.1", topic: "Assess the reliability of the information from different sources", level: 3 },
              { code: "12HIS1.4.3.2", topic: "Compare the reliability of primary and secondary sources with reasons", level: 3 }
            ]
          }
        ]
      },
      {
        id: "12HIS2",
        name: "Early History of Vanuatu",
        icon: "MapPin",
        color: "green",
        hours: 35,
        weight: 20,
        outcome: "Demonstrate understanding of early European contact and colonial administration",
        subStrands: [
          {
            id: "12HIS2.1",
            name: "Early European Contact",
            outcome: "Demonstrate understanding of who the first Europeans were and reasons for their arrival",
            topics: [
              { code: "12HIS2.1.1.1", topic: "Name the early Europeans or foreigners who arrived in Vanuatu", level: 1 },
              { code: "12HIS2.1.1.2", topic: "State the early mode of transportation that brought Europeans to Vanuatu", level: 1 },
              { code: "12HIS2.1.2.1", topic: "Match the names of early Europeans to their countries of origin", level: 2 },
              { code: "12HIS2.1.2.2", topic: "Sketch route maps of early European travels to Vanuatu", level: 2 },
              { code: "12HIS2.1.3.1", topic: "Explain why early Europeans/foreigners came to Vanuatu", level: 3 },
              { code: "12HIS2.1.4.1", topic: "Evaluate texts, pictures or cartoons related to early Europeans arrival", level: 4 }
            ]
          },
          {
            id: "12HIS2.2",
            name: "Impacts and Consequences of Early Europeans",
            outcome: "Demonstrate understanding of positive and negative effects of early Europeans",
            topics: [
              { code: "12HIS2.2.1.1", topic: "Name the goods and materials introduced by early Europeans", level: 1 },
              { code: "12HIS2.2.2.1", topic: "List the changes to Vanuatu society brought about by early European contacts", level: 2 },
              { code: "12HIS2.2.2.2", topic: "Describe the positive effects of early European contacts", level: 2 },
              { code: "12HIS2.2.2.3", topic: "Describe the negative effects of early European contacts", level: 2 },
              { code: "12HIS2.2.3.1", topic: "Explain how early Europeans contributed to the economy", level: 3 },
              { code: "12HIS2.2.4.1", topic: "Critically analyse how introduced goods changed indigenous lives", level: 4 }
            ]
          },
          {
            id: "12HIS2.3",
            name: "Labour Trade",
            outcome: "Demonstrate understanding of the labour trade and its impacts",
            topics: [
              { code: "12HIS2.3.1.1", topic: "Define the term labour trade", level: 1 },
              { code: "12HIS2.3.1.2", topic: "Identify the different groups involved in labour trade", level: 1 },
              { code: "12HIS2.3.2.1", topic: "List features of the labour trade in the Pacific", level: 2 },
              { code: "12HIS2.3.3.1", topic: "Explain why Europeans/foreigners initiated labour trade activities", level: 3 },
              { code: "12HIS2.3.4.1", topic: "Evaluate the impact of labour trade in the Pacific", level: 4 }
            ]
          },
          {
            id: "12HIS2.4",
            name: "Administrators",
            outcome: "Demonstrate understanding of colonial rule in Vanuatu",
            topics: [
              { code: "12HIS2.4.1.1", topic: "Define the term colonial power", level: 1 },
              { code: "12HIS2.4.1.2", topic: "Define the term colonial administration", level: 1 },
              { code: "12HIS2.4.1.3", topic: "Name the two Colonial Administrators of New Hebrides/Vanuatu", level: 1 },
              { code: "12HIS2.4.2.1", topic: "Define the term Condominium Rule", level: 2 },
              { code: "12HIS2.4.3.1", topic: "Discuss contrasting features of condominium rule between French and British", level: 3 },
              { code: "12HIS2.4.4.1", topic: "Evaluate whether both powers achieved their ruling objectives", level: 4 }
            ]
          }
        ]
      },
      {
        id: "12HIS3",
        name: "Forces of Imperialism and Colonialism",
        icon: "Globe",
        color: "purple",
        hours: 20,
        weight: 13,
        outcome: "Demonstrate understanding of the nature and impact of imperialism and colonialism",
        subStrands: [
          {
            id: "12HIS3.1",
            name: "Imperialism and Colonialism",
            outcome: "Demonstrate understanding of differences between imperialism and colonialism",
            topics: [
              { code: "12HIS3.1.1.1", topic: "Define the concept of imperialism", level: 1 },
              { code: "12HIS3.1.1.2", topic: "Define the concept of colonialism", level: 1 },
              { code: "12HIS3.1.2.1", topic: "List the features of colonialism", level: 2 },
              { code: "12HIS3.1.2.2", topic: "List the features of imperialism", level: 2 },
              { code: "12HIS3.1.3.1", topic: "Compare colonialism and imperialism", level: 3 },
              { code: "12HIS3.1.4.1", topic: "Critically analyse positive and negative impacts of imperialism", level: 4 }
            ]
          },
          {
            id: "12HIS3.2",
            name: "German Imperialism and Colonialism",
            outcome: "Demonstrate understanding of Germany's acquisition of Pacific colonies (focus on Samoa)",
            topics: [
              { code: "12HIS3.2.1.1", topic: "Locate Germany on a European map", level: 1 },
              { code: "12HIS3.2.1.2", topic: "Identify the Pacific territories annexed by Germany", level: 1 },
              { code: "12HIS3.2.2.1", topic: "Describe the process of German expansion into the Pacific", level: 2 },
              { code: "12HIS3.2.2.2", topic: "List the reasons for Germany's interest in Samoa", level: 2 },
              { code: "12HIS3.2.3.1", topic: "Discuss how German rule impacted Samoan social structures", level: 3 }
            ]
          },
          {
            id: "12HIS3.3",
            name: "Great Britain: Indirect Rule",
            outcome: "Demonstrate understanding of Britain's acquisition of Pacific colonies (focus on Fiji and New Hebrides)",
            topics: [
              { code: "12HIS3.3.1.1", topic: "Define indirect rule as a colonial administration system", level: 1 },
              { code: "12HIS3.3.1.2", topic: "Locate Britain on a European map", level: 1 },
              { code: "12HIS3.3.2.1", topic: "Describe the system of indirect rule used by Britain", level: 2 },
              { code: "12HIS3.3.3.1", topic: "Explain why Britain used this system of ruling", level: 3 },
              { code: "12HIS3.3.3.2", topic: "Discuss advantages and disadvantages of indirect rule", level: 3 }
            ]
          },
          {
            id: "12HIS3.4",
            name: "France: Direct Rule",
            outcome: "Demonstrate understanding of France's acquisition of Pacific colonies (focus on New Caledonia and New Hebrides)",
            topics: [
              { code: "12HIS3.4.1.1", topic: "Define direct rule or direct administration", level: 1 },
              { code: "12HIS3.4.1.2", topic: "Identify the form of colonisation process used by France", level: 1 },
              { code: "12HIS3.4.1.3", topic: "Name the Pacific territories annexed by France", level: 1 },
              { code: "12HIS3.4.3.1", topic: "Discuss the reasons why France used direct rule", level: 3 }
            ]
          }
        ]
      },
      {
        id: "12HIS4",
        name: "Interwar Period",
        icon: "Swords",
        color: "red",
        hours: 25,
        weight: 15,
        outcome: "Demonstrate understanding of the impacts of WWII on the Pacific",
        subStrands: [
          {
            id: "12HIS4.1",
            name: "Impacts of World War II",
            outcome: "Demonstrate understanding of the impacts of WWII on the Pacific",
            topics: [
              { code: "12HIS4.1.1.1", topic: "Identify the areas of the Pacific affected by WWII", level: 1 },
              { code: "12HIS4.1.2.1", topic: "Describe the effects of WWII on the Pacific", level: 2 },
              { code: "12HIS4.1.3.1", topic: "Explain how WWII changed Pacific societies", level: 3 },
              { code: "12HIS4.1.4.1", topic: "Evaluate the long-term impacts of WWII on the Pacific", level: 4 }
            ]
          },
          {
            id: "12HIS4.2",
            name: "Involvement of Pacific Islanders in WWII",
            outcome: "Demonstrate understanding of how Pacific islanders were involved in WWII",
            topics: [
              { code: "12HIS4.2.1.1", topic: "Name Pacific islands where islanders were involved in WWII", level: 1 },
              { code: "12HIS4.2.2.1", topic: "Describe the roles Pacific islanders played in WWII", level: 2 },
              { code: "12HIS4.2.3.1", topic: "Explain the significance of Pacific islanders' contributions", level: 3 }
            ]
          },
          {
            id: "12HIS4.3",
            name: "Effects of WWII on Pacific Islanders",
            outcome: "Demonstrate understanding of the effects of WWII on Pacific islanders",
            topics: [
              { code: "12HIS4.3.1.1", topic: "Identify the different effects of WWII on Pacific islanders", level: 1 },
              { code: "12HIS4.3.2.1", topic: "Describe positive and negative effects on Pacific communities", level: 2 },
              { code: "12HIS4.3.3.1", topic: "Explain how WWII changed attitudes towards colonialism", level: 3 }
            ]
          },
          {
            id: "12HIS4.4",
            name: "The Cold War",
            outcome: "Demonstrate understanding of the relationship between WWII and the Cold War",
            topics: [
              { code: "12HIS4.4.1.1", topic: "Define the Cold War", level: 1 },
              { code: "12HIS4.4.2.1", topic: "Describe the main features of the Cold War", level: 2 },
              { code: "12HIS4.4.3.1", topic: "Explain the connection between WWII and the Cold War", level: 3 },
              { code: "12HIS4.4.4.1", topic: "Discuss the impacts of the Cold War on the Pacific", level: 4 }
            ]
          }
        ]
      },
      {
        id: "12HIS5",
        name: "Period of Decolonization",
        icon: "Flag",
        color: "orange",
        hours: 25,
        weight: 15,
        outcome: "Demonstrate understanding of various means of decolonization",
        subStrands: [
          {
            id: "12HIS5.1",
            name: "Decolonization by War",
            outcome: "Demonstrate understanding of countries that used war for decolonization",
            topics: [
              { code: "12HIS5.1.1.1", topic: "Name countries that gained independence through war", level: 1 },
              { code: "12HIS5.1.2.1", topic: "Describe the wars of independence in selected countries", level: 2 },
              { code: "12HIS5.1.3.1", topic: "Explain why these countries used war as a means of decolonization", level: 3 },
              { code: "12HIS5.1.4.1", topic: "Evaluate the outcomes of wars of independence", level: 4 }
            ]
          },
          {
            id: "12HIS5.2",
            name: "Decolonization by Political Unrest",
            outcome: "Demonstrate understanding of countries that used political unrest for decolonization",
            topics: [
              { code: "12HIS5.2.1.1", topic: "Name countries that gained independence through political unrest", level: 1 },
              { code: "12HIS5.2.2.1", topic: "Describe political movements that led to independence", level: 2 },
              { code: "12HIS5.2.3.1", topic: "Explain the strategies used in political movements", level: 3 }
            ]
          },
          {
            id: "12HIS5.3",
            name: "Peaceful Decolonization/Negotiated",
            outcome: "Demonstrate understanding of countries that used peaceful methods for decolonization",
            topics: [
              { code: "12HIS5.3.1.1", topic: "Name countries that gained independence through negotiation", level: 1 },
              { code: "12HIS5.3.2.1", topic: "Describe the negotiation processes that led to independence", level: 2 },
              { code: "12HIS5.3.3.1", topic: "Explain why peaceful methods were chosen", level: 3 },
              { code: "12HIS5.3.4.1", topic: "Compare the outcomes of peaceful vs violent decolonization", level: 4 }
            ]
          },
          {
            id: "12HIS5.4",
            name: "Forms of Decolonization in Pacific Island Countries",
            outcome: "Demonstrate understanding of how Pacific colonies obtained independence",
            topics: [
              { code: "12HIS5.4.1.1", topic: "Identify Pacific island countries that gained independence", level: 1 },
              { code: "12HIS5.4.2.1", topic: "Describe the decolonization process in selected Pacific countries", level: 2 },
              { code: "12HIS5.4.3.1", topic: "Explain the factors that influenced decolonization methods", level: 3 }
            ]
          }
        ]
      },
      {
        id: "12HIS6",
        name: "From Independence to the Present",
        icon: "Landmark",
        color: "teal",
        hours: 35,
        weight: 22,
        outcome: "Demonstrate understanding of political developments in newly independent countries",
        subStrands: [
          {
            id: "12HIS6.1",
            name: "New Political Parties in Decolonized Countries",
            outcome: "Demonstrate understanding of new political parties in newly independent countries",
            topics: [
              { code: "12HIS6.1.1.1", topic: "Name political parties that emerged in newly independent countries", level: 1 },
              { code: "12HIS6.1.2.1", topic: "Describe the ideologies of these political parties", level: 2 },
              { code: "12HIS6.1.3.1", topic: "Explain the goals and objectives of these parties", level: 3 }
            ]
          },
          {
            id: "12HIS6.2",
            name: "Emergence of Political Parties in the Pacific",
            outcome: "Demonstrate understanding of new political parties in newly independent Pacific countries",
            topics: [
              { code: "12HIS6.2.1.1", topic: "Name political parties that emerged in Pacific countries", level: 1 },
              { code: "12HIS6.2.2.1", topic: "Describe the features of these Pacific political parties", level: 2 },
              { code: "12HIS6.2.3.1", topic: "Explain how these parties contributed to nation-building", level: 3 }
            ]
          },
          {
            id: "12HIS6.3",
            name: "Birth of Two Political Ideologies in New Hebrides",
            outcome: "Demonstrate understanding of major political ideologies in Vanuatu",
            topics: [
              { code: "12HIS6.3.1.1", topic: "Name the two major political ideologies in pre-independence Vanuatu", level: 1 },
              { code: "12HIS6.3.2.1", topic: "Describe the features of each political ideology", level: 2 },
              { code: "12HIS6.3.3.1", topic: "Explain how these ideologies shaped Vanuatu politics", level: 3 },
              { code: "12HIS6.3.4.1", topic: "Discuss the impacts of these ideologies on independence", level: 4 }
            ]
          },
          {
            id: "12HIS6.4",
            name: "Internal Conflicts among Political Parties in Vanuatu",
            outcome: "Demonstrate understanding of reasons for political divisions in post-independence Vanuatu",
            topics: [
              { code: "12HIS6.4.1.1", topic: "Identify the main political conflicts in post-independence Vanuatu", level: 1 },
              { code: "12HIS6.4.2.1", topic: "Describe the causes of political divisions", level: 2 },
              { code: "12HIS6.4.3.1", topic: "Explain the impacts of political conflicts on Vanuatu", level: 3 },
              { code: "12HIS6.4.4.1", topic: "Evaluate the resolution of political conflicts", level: 4 }
            ]
          }
        ]
      }
    ]
  },
  year13: {
    title: "Year 13 History",
    description: "Advanced historical research, regional perspectives, and Vanuatu's modern development",
    hours: 165,
    strands: [
      {
        id: "13HIS1",
        name: "Skills of History",
        icon: "Search",
        color: "blue",
        hours: 25,
        weight: 15,
        outcome: "Demonstrate understanding of historical research methodology and investigation",
        subStrands: [
          {
            id: "13HIS1.1",
            name: "Studying History and Historical Enquiry",
            outcome: "Demonstrate understanding of the importance of studying history in relation to a career",
            topics: [
              { code: "13HIS1.1.1.1", topic: "Define careers that require historical knowledge", level: 1 },
              { code: "13HIS1.1.2.1", topic: "Describe the process of designing a historical investigation plan", level: 2 },
              { code: "13HIS1.1.3.1", topic: "Explain the importance of historical skills in various careers", level: 3 },
              { code: "13HIS1.1.4.1", topic: "Design a comprehensive plan for a historical investigation", level: 4 }
            ]
          },
          {
            id: "13HIS1.2",
            name: "Conducting a Historical Investigation",
            outcome: "Demonstrate understanding of skills in selecting a topic, applying skills, and presenting results",
            topics: [
              { code: "13HIS1.2.1.1", topic: "Select an appropriate historical topic for investigation", level: 1 },
              { code: "13HIS1.2.2.1", topic: "Describe the methodology for historical research", level: 2 },
              { code: "13HIS1.2.3.1", topic: "Apply historical skills through an investigation", level: 3 },
              { code: "13HIS1.2.4.1", topic: "Conduct a complete historical investigation", level: 4 }
            ]
          },
          {
            id: "13HIS1.3",
            name: "Presentation of Investigation Results",
            outcome: "Demonstrate understanding of skills in presenting investigation results",
            topics: [
              { code: "13HIS1.3.1.1", topic: "Identify different presentation formats", level: 1 },
              { code: "13HIS1.3.2.1", topic: "Describe effective presentation techniques", level: 2 },
              { code: "13HIS1.3.3.1", topic: "Present findings using appropriate historical conventions", level: 3 },
              { code: "13HIS1.3.4.1", topic: "Create a comprehensive presentation of research findings", level: 4 }
            ]
          }
        ]
      },
      {
        id: "13HIS2",
        name: "Early History of Vanuatu",
        icon: "MapPin",
        color: "green",
        hours: 35,
        weight: 20,
        outcome: "Demonstrate understanding of the Condominium system and its operations",
        subStrands: [
          {
            id: "13HIS2.1",
            name: "Joint Naval Commission and the 1906 Convention",
            outcome: "Demonstrate understanding of the reasons for these conventions",
            topics: [
              { code: "13HIS2.1.1.1", topic: "Define the Joint Naval Commission", level: 1 },
              { code: "13HIS2.1.1.2", topic: "State the year of the 1906 Convention", level: 1 },
              { code: "13HIS2.1.2.1", topic: "Describe the terms of the 1906 Convention", level: 2 },
              { code: "13HIS2.1.3.1", topic: "Explain the reasons for these conventions", level: 3 },
              { code: "13HIS2.1.4.1", topic: "Evaluate the effectiveness of these conventions", level: 4 }
            ]
          },
          {
            id: "13HIS2.2",
            name: "1914 Protocol",
            outcome: "Demonstrate understanding to critique the 1914 Protocol and its usefulness to locals",
            topics: [
              { code: "13HIS2.2.1.1", topic: "State the purpose of the 1914 Protocol", level: 1 },
              { code: "13HIS2.2.2.1", topic: "Describe the terms of the 1914 Protocol", level: 2 },
              { code: "13HIS2.2.3.1", topic: "Explain how the Protocol affected local people", level: 3 },
              { code: "13HIS2.2.4.1", topic: "Critically evaluate the usefulness of the Protocol to locals", level: 4 }
            ]
          },
          {
            id: "13HIS2.3",
            name: "The Condominium Regime",
            outcome: "Demonstrate understanding of the establishment and operations of the Condominium",
            topics: [
              { code: "13HIS2.3.1.1", topic: "Define the Condominium regime", level: 1 },
              { code: "13HIS2.3.2.1", topic: "Describe the structure of the Condominium government", level: 2 },
              { code: "13HIS2.3.3.1", topic: "Explain how the Condominium operated in Vanuatu", level: 3 },
              { code: "13HIS2.3.4.1", topic: "Evaluate the impacts of the Condominium on Vanuatu", level: 4 }
            ]
          }
        ]
      },
      {
        id: "13HIS3",
        name: "Forces of Imperialism and Colonialism",
        icon: "Globe",
        color: "purple",
        hours: 20,
        weight: 13,
        outcome: "Demonstrate understanding of the forces and impacts of imperialism and colonialism",
        subStrands: [
          {
            id: "13HIS3.1",
            name: "Imperialism and Colonialism",
            outcome: "Demonstrate understanding of the forces of imperialism and colonialism",
            topics: [
              { code: "13HIS3.1.1.1", topic: "Define the forces that drove imperial expansion", level: 1 },
              { code: "13HIS3.1.2.1", topic: "Describe the motivations for colonialism", level: 2 },
              { code: "13HIS3.1.3.1", topic: "Explain the economic, political, and social forces behind imperialism", level: 3 }
            ]
          },
          {
            id: "13HIS3.2",
            name: "Nature of Partition and Patterns of Imperial Powers",
            outcome: "Demonstrate understanding of the partition of the Pacific and administrative patterns",
            topics: [
              { code: "13HIS3.2.1.1", topic: "Identify the patterns of imperial administration", level: 1 },
              { code: "13HIS3.2.2.1", topic: "Describe how the Pacific was partitioned", level: 2 },
              { code: "13HIS3.2.3.1", topic: "Explain the different patterns of imperial administration", level: 3 },
              { code: "13HIS3.2.4.1", topic: "Compare the administrative approaches of different imperial powers", level: 4 }
            ]
          },
          {
            id: "13HIS3.3",
            name: "Impact of Imperial Expansion",
            outcome: "Demonstrate understanding of the social, economic, and political impacts of imperialism",
            topics: [
              { code: "13HIS3.3.1.1", topic: "Identify the impacts of imperial expansion", level: 1 },
              { code: "13HIS3.3.2.1", topic: "Describe social impacts on indigenous populations", level: 2 },
              { code: "13HIS3.3.3.1", topic: "Explain economic changes caused by imperialism", level: 3 },
              { code: "13HIS3.3.4.1", topic: "Evaluate the long-term impacts of imperial expansion", level: 4 }
            ]
          }
        ]
      },
      {
        id: "13HIS4",
        name: "Interwar Period",
        icon: "Swords",
        color: "red",
        hours: 25,
        weight: 15,
        outcome: "Demonstrate understanding of political, administrative, and environmental changes",
        subStrands: [
          {
            id: "13HIS4.1",
            name: "Political and Administrative Changes",
            outcome: "Demonstrate understanding of political and administrative changes in Pacific island countries",
            topics: [
              { code: "13HIS4.1.1.1", topic: "Identify political changes that occurred after WWII", level: 1 },
              { code: "13HIS4.1.2.1", topic: "Describe administrative reforms in Pacific countries", level: 2 },
              { code: "13HIS4.1.3.1", topic: "Explain how WWII changed Pacific governance", level: 3 },
              { code: "13HIS4.1.4.1", topic: "Evaluate the effectiveness of post-war administrative changes", level: 4 }
            ]
          },
          {
            id: "13HIS4.2",
            name: "Environmental Impacts of WWII",
            outcome: "Demonstrate understanding of environmental impacts of WWII in Pacific island countries",
            topics: [
              { code: "13HIS4.2.1.1", topic: "Identify environmental damage caused by WWII", level: 1 },
              { code: "13HIS4.2.2.1", topic: "Describe specific environmental impacts in Pacific countries", level: 2 },
              { code: "13HIS4.2.3.1", topic: "Explain the long-term environmental consequences", level: 3 },
              { code: "13HIS4.2.4.1", topic: "Evaluate environmental recovery efforts", level: 4 }
            ]
          },
          {
            id: "13HIS4.3",
            name: "Changes in Attitudes",
            outcome: "Demonstrate understanding of how WWII contributed to decolonization",
            topics: [
              { code: "13HIS4.3.1.1", topic: "Identify attitude changes among Pacific islanders after WWII", level: 1 },
              { code: "13HIS4.3.2.1", topic: "Describe how exposure to Americans changed local perspectives", level: 2 },
              { code: "13HIS4.3.3.1", topic: "Explain how WWII accelerated decolonization movements", level: 3 },
              { code: "13HIS4.3.4.1", topic: "Evaluate the connection between WWII and independence movements", level: 4 }
            ]
          }
        ]
      },
      {
        id: "13HIS5",
        name: "Period of Decolonization",
        icon: "Flag",
        color: "orange",
        hours: 25,
        weight: 15,
        outcome: "Demonstrate understanding of decolonization impacts globally and in the Pacific",
        subStrands: [
          {
            id: "13HIS5.1",
            name: "Decolonization in Asia and Africa",
            outcome: "Demonstrate understanding of decolonization impacts in Asia and Africa",
            topics: [
              { code: "13HIS5.1.1.1", topic: "Name Asian and African countries that gained independence", level: 1 },
              { code: "13HIS5.1.2.1", topic: "Describe the decolonization process in selected countries", level: 2 },
              { code: "13HIS5.1.3.1", topic: "Explain the factors that led to decolonization", level: 3 },
              { code: "13HIS5.1.4.1", topic: "Evaluate the impacts of decolonization on these regions", level: 4 }
            ]
          },
          {
            id: "13HIS5.2",
            name: "Decolonized Countries of the Pacific",
            outcome: "Demonstrate understanding of decolonization impacts in newly independent Pacific countries",
            topics: [
              { code: "13HIS5.2.1.1", topic: "Name Pacific countries that gained independence", level: 1 },
              { code: "13HIS5.2.2.1", topic: "Describe the independence process in Pacific countries", level: 2 },
              { code: "13HIS5.2.3.1", topic: "Explain challenges faced by newly independent Pacific nations", level: 3 },
              { code: "13HIS5.2.4.1", topic: "Compare decolonization experiences across Pacific countries", level: 4 }
            ]
          },
          {
            id: "13HIS5.3",
            name: "The Emergence of New Countries",
            outcome: "Demonstrate understanding of features of third world countries and their emergence",
            topics: [
              { code: "13HIS5.3.1.1", topic: "Define the term 'third world countries'", level: 1 },
              { code: "13HIS5.3.2.1", topic: "Describe the characteristics of newly independent nations", level: 2 },
              { code: "13HIS5.3.3.1", topic: "Explain the challenges of nation-building", level: 3 },
              { code: "13HIS5.3.4.1", topic: "Evaluate the development of newly independent countries", level: 4 }
            ]
          }
        ]
      },
      {
        id: "13HIS6",
        name: "From Independence to the Present",
        icon: "Landmark",
        color: "teal",
        hours: 35,
        weight: 22,
        outcome: "Demonstrate understanding of Vanuatu's journey to independence and regional policy",
        subStrands: [
          {
            id: "13HIS6.1",
            name: "From New Hebrides to Vanuatu",
            outcome: "Demonstrate understanding of the approach taken by Vanuatu to gain its national identity",
            topics: [
              { code: "13HIS6.1.1.1", topic: "State the date of Vanuatu's independence", level: 1 },
              { code: "13HIS6.1.2.1", topic: "Describe the events leading to independence", level: 2 },
              { code: "13HIS6.1.3.1", topic: "Explain the significance of the name change to Vanuatu", level: 3 },
              { code: "13HIS6.1.4.1", topic: "Evaluate Vanuatu's approach to nation-building", level: 4 }
            ]
          },
          {
            id: "13HIS6.4",
            name: "After Independence",
            outcome: "Demonstrate understanding of Vanuatu's regional policy and its implications since 1991",
            topics: [
              { code: "13HIS6.4.1.1", topic: "Identify Vanuatu's regional affiliations", level: 1 },
              { code: "13HIS6.4.2.1", topic: "Describe Vanuatu's foreign policy objectives", level: 2 },
              { code: "13HIS6.4.3.1", topic: "Explain Vanuatu's role in regional organizations", level: 3 },
              { code: "13HIS6.4.4.1", topic: "Evaluate Vanuatu's regional policy since independence", level: 4 }
            ]
          }
        ]
      }
    ]
  }
};

export default historyCurriculum;
